// @flow
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { getCountDown } from '../../utils/countDown';
import styles from './CatalogDate.module.scss';

type Props = {
    className: string,
    date: number,
    forceYear?: boolean,
    showDate: boolean,
};

type State = {
    countDown: boolean,
    dateFormat: string,
};

export default class CatalogDate extends PureComponent<Props, State> {
    static defaultProps = {
        className: '',
        date: 0,
        forceYear: true,
        showDate: true,
    };

    state = getCountDown(this.props.date, this.props.forceYear);

    componentDidMount() {
        if (this.state.countDown) {
            this.timeout = setTimeout(this.updateCountdown, 30000);
        }
    }

    componentDidUpdate(prevProps: Props) {
        if (this.props.date !== prevProps.date) {
            this.updateCountdown();
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timeout);
    }

    timeout: TimeoutID;
    reference: ?HTMLSpanElement;

    updateCountdown = () => {
        // we check to see if the component still exists so that we dont try and set state on an unmounted component
        if (this.reference) {
            const { countDown, dateFormat } = getCountDown(this.props.date, this.props.forceYear);
            this.setState(
                {
                    countDown,
                    dateFormat,
                },
                () => {
                    if (this.state.countDown) {
                        this.timeout = setTimeout(this.updateCountdown, 30000);
                    }
                }
            );
        }
    };

    render() {
        const { className, showDate } = this.props;
        const classes = classNames(styles['card-date'], className);
        const { countDown, dateFormat } = this.state;

        let displayDate = countDown ? (
            <span className={styles.countdown}>
                <FormattedMessage id="left" values={{ dateFormat }} />
            </span>
        ) : (
            <span className={styles.date}>{dateFormat}</span>
        );

        return (
            showDate && (
                <span ref={ref => (this.reference = ref)} className={classes}>
                    {displayDate}
                </span>
            )
        );
    }
}
